// Client du runtime JavaScript des leçons Reps : jumeau de pyodideRunner.js,
// avec la même forme de résultat pour que les consoles ne fassent aucune
// différence entre les deux langages.
//
// Différence de fond : ici CHAQUE exécution a son worker, jeté ensuite. Python
// rejoue un dictionnaire neuf dans un interpréteur partagé ; JavaScript n'a pas
// d'équivalent, et démarrer un worker ne prend presque rien (pas de Pyodide à
// charger).

const WORKER_URL = "/static/reps/js-worker.js";
// Bien plus court que les 12 s de Python : rien à télécharger, et une leçon se
// joue sur le pouce.
const RUN_TIMEOUT_MS = 4000;

// Même phrase que pyodideRunner.js : c'est elle que la console affiche.
const TROP_LONG = "Ton code a mis trop de temps (boucle infinie ?). Exécution arrêtée.";

// Le nom que la console montre à côté du numéro de ligne.
export const JS_FILE_NAME = "script.js";

// Ce que la console affiche d'une erreur : son nom et son message, puis le
// fichier et la ligne, comme dans un navigateur.
export function texteErreur(erreur) {
    if (!erreur) return "";
    return erreur.ligne ? `${erreur.texte}\n    at ${JS_FILE_NAME}:${erreur.ligne}` : erreur.texte;
}

// Appels sérialisés, comme pyodideRunner.js : deux consoles qui se montent en
// même temps n'ont pas à se marcher dessus.
let queue = Promise.resolve();

export function runJs(code) {
    const next = queue.then(() => runNow(code));
    queue = next.catch(() => {});
    return next;
}

function runNow(code) {
    return new Promise((resolve) => {
        if (typeof Worker === "undefined") {
            resolve({ stdout: "", stderr: "", ok: false, timedOut: false, unavailable: true, error: "Worker indisponible." });
            return;
        }
        let worker;
        try {
            worker = new Worker(WORKER_URL);
        } catch (e) {
            resolve({ stdout: "", stderr: "", ok: false, timedOut: false, unavailable: true, error: String((e && e.message) || e) });
            return;
        }
        let fini = false;
        const finir = (resultat) => {
            if (fini) return;
            fini = true;
            clearTimeout(timer);
            worker.terminate();
            resolve(resultat);
        };
        const timer = setTimeout(() => {
            finir({ stdout: "", stderr: "", ok: false, timedOut: true, error: TROP_LONG });
        }, RUN_TIMEOUT_MS);
        worker.onmessage = (e) => {
            const msg = e.data || {};
            if (msg.type === "ready") {
                worker.postMessage({ type: "run", code: String(code || "") });
                return;
            }
            if (msg.type !== "done") return;
            if (msg.arrete) {
                finir({ stdout: msg.stdout || "", stderr: msg.stderr || "", ok: false, timedOut: true, error: TROP_LONG });
                return;
            }
            finir({
                stdout: msg.stdout || "",
                stderr: msg.stderr || "",
                ok: !msg.erreur,
                timedOut: false,
                error: msg.erreur ? texteErreur(msg.erreur) : undefined,
                erreur: msg.erreur || null,
            });
        };
        // Le worker lui-même n'a pas pu se charger (fichier absent, réseau).
        worker.onerror = (ev) => {
            if (ev && ev.preventDefault) ev.preventDefault();
            finir({ stdout: "", stderr: "", ok: false, timedOut: false, unavailable: true, error: String((ev && ev.message) || "worker") });
        };
    });
}

// Rien à préchauffer : gardé pour que les appelants traitent les deux langages
// de la même façon.
export function warmJs() {}
